import React from "react";
import {
  List,
  Filter,
  Datagrid,
  TextField,
  ReferenceField,
  EditButton,
  DateField,
  SelectInput,
  ReferenceInput,
  ReferenceArrayInput,
  SelectArrayInput,
  SelectField,
  ChipField
} from "react-admin/lib";
import { SUPERADMIN } from "../../constant/TypeRole";
import { typeMessage } from "../../constant/TypeMessage";
import Actions from '../Actions'

const MessageFilter = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { _id: project }) : {};
  return (
    <Filter {...props}>
      <SelectInput source="type" choices={typeMessage} />
      <ReferenceArrayInput
        alwaysOn
        style={{ minWidth: "200px" }}
        source="project"
        reference="project"
        filter={filter}
      >
        <SelectArrayInput optionText="name" />
      </ReferenceArrayInput>
    </Filter>
  );
};

export const MessageList = props => {
  const role = localStorage.getItem("role");
  const project = JSON.parse(localStorage.getItem("project"));
  const filter = role ? (role === SUPERADMIN ? {} : { project }) : { project };
  return (
    <List
      {...props}
      actions={<Actions create />}
      title="message.message"
      bulkActions={false}
      filters={<MessageFilter />}
      sort={{ field: "createdAt", order: "DESC" }}
      filterDefaultValues={filter}
    >
      <Datagrid>
        <div />
        <TextField source="title" />
        <SelectField
          source="type"
          optionText={<ChipField source="name" />}
          choices={typeMessage}
        />
        <ReferenceField linkType={false} source="project" reference="project">
          <ChipField source="name" />
        </ReferenceField>
        <ReferenceField linkType={false} source="user" reference="user" label="ส่งไปยัง">
          <TextField source="email" />
        </ReferenceField>
        <DateField
          source="createdAt"
          label="วันที่"
          locales="th-TH"
          options={{
            day: "numeric",
            month: "short",
            year: "numeric",
            hour: "numeric",
            minute: "numeric"
          }}
        />
        <EditButton />
      </Datagrid>
    </List>
  );
};



// WEBPACK FOOTER //
// ./src/components/message/MessageList.js